import { render, staticRenderFns } from "./ResourceItemTable.vue?vue&type=template&id=7f89c10e&scoped=true&"
import script from "./ResourceItemTable.vue?vue&type=script&lang=ts&"
export * from "./ResourceItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceItemTable.vue?vue&type=style&index=0&id=7f89c10e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f89c10e",
  null
  
)

export default component.exports